import { Component, OnInit , Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-patient-case-card',
  templateUrl: './patient-case-card.component.html',
  styleUrls: ['./patient-case-card.component.css']
})
export class PatientCaseCardComponent implements OnInit {

  constructor() { }

  @Input() caseList;
  @Output() codeAction = new EventEmitter();
  @Output() pdfAction = new EventEmitter();

  ngOnInit() {
  }

  onCodes(data) {
    this.codeAction.emit(data);
  }

  onPdf(data) {
    this.pdfAction.emit(data);

  }

}
